import { DeviationStatus } from '../enums/driver-deviation-enums';
import { DriverInfo } from './driver-info.model';
import { ConflictGroup } from './conflict-group.model';

export class TrainDeviation {
  constructor(
    public id: string,
    public trainNumber: string,
    public trafficDate: string,
    public route: {
      origin: string;
      destination: string;
      departureAtUtc: Date;
      arrivalAtUtc: Date;
    },
    public status: DeviationStatus,
    public conflictGroups: ConflictGroup[],
    public note: string,
    public isHandled: boolean,
    public lastUpdated?: Date
  ) {}

  /** Flat list of all drivers across every conflict group. */
  get allDrivers(): DriverInfo[] {
    return this.conflictGroups.flatMap(g => g.trainDrivers);
  }
}
